import React, { useState, useEffect } from "react";
import {
  Userlogin,
  GetDealerdata,
  Toast,
  fetchDataFromApi,
  shareIphonePostMsg,
  formateNumberStNdRd,
} from "./Utils/general-function";
import { useNavigate, Link, useParams } from "react-router-dom";
import Header from "./Header";
import Loader from "./Utils/Loader";
import QRCode from "qrcode.react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Search from "./Search";
import html2pdf from "html2pdf.js";
import NoCars from "./Utils/NoCars";

function GenerateQr(props) {
  const [catloguelist, setCatloguelist] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  let params = useParams();
  const [apiData, setapiData] = useState({});
  const [originalList, setOriginalList] = useState([]);
  const iphone = window.navigator.userAgent.includes("Mac");

  useEffect(() => {
    const fetchdata = async () => {
      if (!Userlogin()) {
        navigate("/Login");
        return;
      }
      try {
        GetDealerdata().then((res) => {
          setapiData(res);
        });
        const carlist = await fetchDataFromApi(
          "/api/CarCateloge/AllCatelogebycarnoDealerid?carno=0&carstatus=Catlogue",
        );
        setCatloguelist(carlist.Data || []);
        setOriginalList(carlist.Data || []);
        setLoading(false);
      } catch (error) {
        console.log("Exception Found:", error);
        setLoading(false);
      }
    };
    fetchdata();
  }, [navigate, params.id]);

  // const downloadQR = async (name, id) => {
  //   setLoading(true);
  //   const min = 1;
  //   const max = 500;
  //   const rand = parseInt(min + Math.random() * (max - min));
  //   const canvas1 = await document.getElementById(id);
  //   canvas1.style.display = "block";
  //   try {
  //     html2canvas(canvas1).then((canvas) => {
  //       const pngUrl = canvas.toDataURL("image/png");

  //       if (iphone) {
  //         shareIphonePostMsg({
  //           data: pngUrl,
  //           action: "sharebase64",
  //           filename: name + "QR" + rand + ".pdf",
  //         });
  //         return setLoading(false);
  //       }
  //       // android
  //       const pdf = new jsPDF();
  //       pdf.addImage(pngUrl, "PNG", 12.3, 12.3, 185, 291, "", "SLOW");
  //       pdf.save(name + "QR" + rand);
  //       setLoading(false);
  //       Toast(true, "Qr generated Successfully", "");
  //     });
  //   } catch (e) {
  //     Toast(false, "", e);
  //   }

  //   canvas1.style.display = "none";
  // };

  const downloadDetails = async (name, id) => {
    setLoading(true);
    // const min = 1;
    // const max = 500;
    // const rand = parseInt(min + Math.random() * (max - min));

    const rand = Math.floor(Math.random() * 500) + 1;
    const canvas1 = await document.getElementById(id);
    canvas1.style.display = "block";
    let filename = name + "Details" + rand + ".pdf";

    try {
      const options = {
        // pagebreak:{ mode: ['avoid-all', 'css', 'legacy'] },

        margin: [4, 2, 2, 0],
        filename: filename,
        image: {
          type: "jpeg",
          quality: 1.0,
        },
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          allowTaint: true,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
          compress: true,
        },
      };
      if (iphone) {
        let bs64 = await html2pdf()
          .from(canvas1)
          .set(options)
          .toPdf()
          .outputPdf("datauristring");
        return shareIphonePostMsg({
          data: bs64,
          filename,
          action: "sharebase64",
        });
      }
      await html2pdf().from(canvas1).set(options).toPdf().get("pdf").save();
      Toast(true, "Qr generated Successfully", "");
    } catch (e) {
      Toast(false, "", e);
      console.error(e);
    } finally {
      canvas1.style.display = "none";
      setLoading(false);
    }
  };

  const handleCallback = (childData) => {
    setLoading(true);
    setCatloguelist(childData);
    setLoading(false);
  };

  return (
    <div>
      <Header />
      {loading ? <Loader /> : null}
      <div className="page-space">
        <Search dataFromParent={originalList} parentCallback={handleCallback} />

        {catloguelist.length === 0 ? (
          <NoCars />
        ) : (
          catloguelist.map((list, index) => (
            <div key={list.carid}>
              <div className="oldcatlg-div">
                <div className="oldcatlg-img">
                  <Link to={"/Catlogue_Detail/" + list.Rand}>
                    <img src={list.carphoto} className="img-fluid" alt="" />
                  </Link>
                </div>

                <div className="oldcatlg-text">
                  <h2>
                    {list.modelyear} {list.companyid} {list.carmodelid}{" "}
                    {list.variantid}
                  </h2>
                  <div className="oldcatlg-number">
                    <span>{list.carnumber}</span> •
                    {list.km && <span> {list.km} km •</span>}
                    <span> {list.fueltypeid}</span>
                    <span> • {formateNumberStNdRd(list.owner)} Owner</span>
                  </div>
                  <button
                    className="mdbtn border-0 me-2"
                    // onClick={(e) => downloadQR(list.carnumber, list.Rand)}
                    onClick={(e) =>
                      downloadDetails(list.carnumber, list.Rand + "Detail")
                    }
                  >
                    Get QR
                  </button>
                  {/* <button
                    className="mdbtn border-0"
                    onClick={(e) =>
                      downloadDetails(list.carnumber, list.Rand + "Detail")
                    }
                  >
                    Get Details
                  </button> */}
                  <div></div>
                </div>
              </div>

              {/* ---------------------get Details Section-------------- */}
              <div
                id={list.Rand + "Detail"}
                style={{ display: "none" }}
                className="div_print"
              >
                <div className="text-center">
                  <span>
                    <img
                      src="assets/images/logo.png"
                      alt=""
                      style={{ width: "35%" }}
                    />
                  </span>
                </div>
                <div
                  className="qrdiv"
                  style={{ width: "700px", top: "53%", padding: "40px" }}
                >
                  <h1>
                    {list.modelyear} {list.companyid} {list.carmodelid}{" "}
                    {list.variantid}
                  </h1>
                  <div className="catlg-number mb-2">
                    <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                      {list.carnumber}
                    </span>
                    {list.km && (
                      <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                        {" "}
                        • {list.km} km
                      </span>
                    )}
                    <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                      {" "}
                      • {list.fueltypeid}
                    </span>
                  </div>
                  {/* <div className="car-grid"> */}
                  <div className="d-grid gap-3">
                    <div className="car-details print-deail qrcodedetFlex">
                      <div className="myflex">
                        <span className="material-symbols-outlined qrcodedetailIcon">
                          person
                        </span>
                        <span
                          className="title"
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          Ownership
                        </span>
                      </div>
                      <div className="info pt-detailval">
                        {list?.owner} <span>Owner</span>
                      </div>
                    </div>
                    <div className="car-details print-deail qrcodedetFlex">
                      <div className="myflex">
                        {/* <img src="assets/images/fuel.svg" alt="" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 512 512"
                          style={{ height: "23px" }}
                          xmlSpace="preserve"
                          className="qrcodedetailIcon"
                        >
                          <g>
                            <path
                              d="M451.366 162.807c0-30.186-14.941-53.063-31.585-75.764L351.512 0l-67.973 86.653-.295.389c-4.489 6.122-8.85 12.258-12.832 18.545l-37.264-47.509-116.07 147.967-.295.389c-29.589 40.356-56.149 80.898-56.149 133.049 0 94.898 77.02 172.145 171.833 172.513l.703.004c95.113 0 172.492-77.389 172.492-172.514 0-30.527-9.109-57.074-22.592-81.937 39.641-13.236 68.296-50.703 68.296-94.742zM233.819 481.958l-.671-.001c-78.56 0-142.473-63.913-142.473-142.473 0-43.051 22.717-77.607 50.19-115.09l92.283-117.641 22.714 28.956c-2.652 8.435-4.204 17.386-4.204 27.097 0 54.841 44.444 99.499 99.204 99.853l.586.003c14.432 24.104 24.174 48.645 24.174 76.825 0 78.343-63.551 142.121-141.803 142.471zm118.08-249.339h-.388c-38.495 0-69.813-31.318-69.813-69.814 0-21.1 11.097-37.974 25.628-57.804l44.186-56.328 44.186 56.328c14.531 19.83 25.628 36.706 25.628 57.806-.001 38.371-31.109 69.611-69.427 69.812z"
                              fill="#000000"
                              opacity={1}
                              data-original="#000000"
                              className=""
                            />
                          </g>
                        </svg>

                        <span
                          className="title"
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          Fuel Type
                        </span>
                      </div>
                      <div className="info pt-detailval">
                        {list?.fueltypeid}
                      </div>
                    </div>
                    <div className="car-details print-deail qrcodedetFlex">
                      <div className="myflex">
                        <span className="material-symbols-outlined qrcodedetailIcon">
                          palette
                        </span>
                        <span
                          className="title"
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          Color
                        </span>
                      </div>
                      <div className="info pt-detailval">{list?.colour}</div>
                    </div>
                    <div className="car-details print-deail qrcodedetFlex">
                      <div className="myflex">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 24 24"
                          style={{ height: "23px" }}
                          xmlSpace="preserve"
                          fillRule="evenodd"
                          className=""
                        >
                          <g>
                            <path
                              d="M7.354 16.507a2.75 2.75 0 0 0 2.703 2.243h7.341a1.75 1.75 0 0 0 1.75-1.75v-2a2.752 2.752 0 0 0-2.75-2.75h-4.166a.25.25 0 0 1-.246-.205l-1.552-8.537A2.75 2.75 0 0 0 7.728 1.25H6.602a1.75 1.75 0 0 0-1.72 2.073zm1.475-.277L6.357 3.046a.252.252 0 0 1 .053-.206.251.251 0 0 1 .192-.09h1.126a1.25 1.25 0 0 1 1.23 1.026l1.552 8.537a1.75 1.75 0 0 0 1.722 1.437h4.166a1.25 1.25 0 0 1 1.25 1.25v2a.25.25 0 0 1-.25.25h-7.341a1.25 1.25 0 0 1-1.228-1.02z"
                              fill="#000000"
                              opacity={1}
                              data-original="#000000"
                              className=""
                            />
                            <path
                              d="m11.262 17.603-1.544 2.469a1.752 1.752 0 0 0 1.484 2.678h6.696a.75.75 0 0 0 0-1.5h-6.696a.25.25 0 0 1-.212-.383l1.544-2.47a.75.75 0 0 0-1.272-.794zM10.898 9.75h6a.75.75 0 0 0 0-1.5h-6a.75.75 0 0 0 0 1.5z"
                              fill="#000000"
                              opacity={1}
                              data-original="#000000"
                              className=""
                            />
                          </g>
                        </svg>

                        <span
                          className="title"
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          Seating Capacity
                        </span>
                      </div>
                      <div className="info pt-detailval">
                        {list?.seatingcapicity}
                      </div>
                    </div>
                    <div className="car-details print-deail qrcodedetFlex">
                      <div className="myflex">
                        <span
                          className="material-symbols-outlined qrcodedetailIcon"
                          style={{ fontWeight: "400" }}
                        >
                          auto_transmission
                        </span>
                        <span
                          className="title"
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          Gear
                        </span>
                      </div>
                      <div className="info pt-detailval">{list?.gear}</div>
                    </div>
                    <div className="car-details print-deail qrcodedetFlex">
                      <div className="myflex">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 128 128"
                          style={{ height: "27px" }}
                          xmlSpace="preserve"
                        >
                          <g>
                            <path
                              d="M55 24H45a2 2 0 0 0 0 4h5.17l-6.58 6.59a2 2 0 0 0 2.82 2.82L53 30.83V36a2 2 0 0 0 4 0V26a2 2 0 0 0-2-2zM125.54 80c0-1.11-.21-3.92-1.61-5.32-3.55-3.54-23.87-8.72-31.26-10.78-1.89-1-15.1-8.26-19.32-10.06a40.28 40.28 0 0 0-8.78-1.7l-31.72-15a2 2 0 0 0-1.7 3.62l22.2 10.48c-9.9-.42-20.82-.08-30.61 1.87-5.66 1.13-13.53 8-15.83 10.26C4.29 66 4.75 70.78 4 72.36c-2.07 4.12-1.73 5.79-1.91 8.91s.1 5.82 5.52 8a29.46 29.46 0 0 0 6 1.33A11.51 11.51 0 0 0 35 91.83l58 1.71a11.51 11.51 0 0 0 18.87.14 54.57 54.57 0 0 0 10-1.24 2 2 0 0 0 1-.53 14.46 14.46 0 0 0 2.43-3.6c1.23-2.4.49-6.97.24-8.31zm-101 14.5a7.54 7.54 0 1 1 7.52-7.5 7.54 7.54 0 0 1-7.53 7.53zm78 0a7.54 7.54 0 1 1 7.52-7.5 7.54 7.54 0 0 1-7.53 7.53zm19.23-8a13.63 13.63 0 0 1-1.35 2.16 54.44 54.44 0 0 1-6.66.91 11.53 11.53 0 1 0-22.48-.1L36 87.86a11.52 11.52 0 1 0-23-1.39 21.67 21.67 0 0 1-3.95-.91c-3.19-1.28-3.15-1.93-3-4 .18-3-.2-4 1.49-7.36 1.16-2.31.82-6.52 2.2-7.9 2.52-2.51 9.49-8.31 13.79-9.17 18-3.58 44-1.36 48.26.46s19 9.93 19.16 10a2.26 2.26 0 0 0 .43.17c7.13 2 26.49 7 29.7 9.79.44.6.46 2.86.51 3.11.41 2.12.59 5 .17 5.86z"
                              fill="#000000"
                              opacity={1}
                              data-original="#000000"
                            />
                          </g>
                        </svg>

                        <span
                          className="title"
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          Sunroof
                        </span>
                      </div>
                      <div className="info pt-detailval">{list?.nSunRoof}</div>
                    </div>
                    <div className="car-details print-deail qrcodedetFlex">
                      <div className="myflex">
                        {/* <span>
                          <img src="assets/images/insurance.svg" alt="" />
                        </span> */}

                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 682 682.667"
                          style={{ height: "23px" }}
                          xmlSpace="preserve"
                          className=""
                        >
                          <g>
                            <path
                              d="m262.059 640-9.93-4.512c-87.656-39.843-162.832-98.926-223.426-175.62-20.66-26.141-32.035-59.016-32.035-92.571V0l34.797 14.93c42.422 18.203 76.77 26.68 108.078 26.68 54.812 0 109.18-33.329 109.723-33.665l12.793-7.93 13.02 7.587c.534.308 56.929 32.78 111.534 32.78 39.461 0 77.285-13.655 105.828-25.554L527 .43v370.394c0 31.672-9.781 61.957-28.281 87.606-56.504 78.285-132.746 137.957-226.602 177.347zM46.579 74.355v292.942c0 22.371 7.558 44.258 21.288 61.629 53.317 67.476 118.88 120.078 194.992 156.488 80.657-35.75 146.352-88.262 195.383-156.2 12.324-17.081 18.844-37.277 18.844-58.39V74.027c-26.707 8.977-57.563 16.266-90.473 16.266-51.242 0-100.941-21.348-123.8-32.73-22.508 11.859-71.407 33.96-123.27 33.96-33.89.004-66.129-7.949-92.965-17.168zm370.16 155.856-35.294-35.293-146.75 146.758-81.246-81.246-35.297 35.293 116.543 116.539zm0 0"
                              fill="#000000"
                              opacity={1}
                              data-original="#000000"
                            />
                          </g>
                        </svg>

                        <span
                          className="title"
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          Insurance
                        </span>
                      </div>
                      <div className="info pt-detailval">
                        {list?.insurance === "Yes"
                          ? list?.insurance + "-" + list?.nInsurancetype
                          : list?.insurance}
                      </div>
                    </div>
                    {list?.insurance === "Yes" ? (
                      <>
                        <div className="car-details print-deail qrcodedetFlex">
                          <div className="myflex">
                            {/* <span>
                              <img
                                src="assets/images/registrationyear.svg"
                                alt=""
                              />
                            </span> */}
                            <span className="material-symbols-outlined qrcodedetailIcon">
                              calendar_today
                            </span>
                            <span
                              className="title"
                              style={{
                                fontSize: "16px",
                                fontWeight: "500",
                              }}
                            >
                              Insurance End Date
                            </span>
                          </div>
                          <div className="info pt-detailval">
                            {new Date(
                              list?.insuranceendtdate,
                            ).toLocaleDateString("es-CL")}
                          </div>
                        </div>
                      </>
                    ) : null}
                  </div>
                  {/* footer firm name and qr code */}
                  <div className="d-flex align-items-center justify-content-between">
                    <div style={{ marginTop: "50px" }}>
                      {apiData?.Logoname && (
                        <img
                          src={apiData?.Logo}
                          style={{ height: "100px" }}
                          alt=""
                        />
                      )}
                      <h3
                        style={{
                          fontSize: "24px",
                          lineHeight: "34px",
                          fontWeight: "500",
                        }}
                      >
                        {apiData.Firmname}
                      </h3>
                      <h3
                        style={{
                          fontSize: "24px",
                          lineHeight: "34px",
                          fontWeight: "500",
                        }}
                      >
                        {apiData.Mobileno}
                        {apiData.Mobileno1
                          ? " | " + apiData.Mobileno1.replace("/", " | ")
                          : " "}
                      </h3>
                    </div>
                    <QRCode
                      value={
                        "https://m.carthi.in/#/Leadform/" +
                        list.carnumber +
                        "/" +
                        list.Rand +
                        "/" +
                        apiData.DealerRand
                      }
                      size={220}
                      level={"H"}
                      includeMargin={true}
                      style={{ marginTop: "50px" }}
                    />
                  </div>

                  <img
                    src="assets/images/scissors.png"
                    className="scissors"
                    alt=""
                  />
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default GenerateQr;

// below is old and production code

// import React, { useState, useEffect } from "react";
// import {
//   Userlogin,
//   GetDealerdata,
//   Toast,
//   fetchDataFromApi,
//   shareIphonePostMsg,
// } from "./Utils/general-function";
// import { useNavigate, Link, useParams } from "react-router-dom";
// import Header from "./Header";
// import Loader from "./Utils/Loader";
// import QRCode from "qrcode.react";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import Search from "./Search";
// import html2pdf from "html2pdf.js";
// import NoCars from "./Utils/NoCars";

// function GenerateQr(props) {
//   const [catloguelist, setCatloguelist] = useState([]);
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   let params = useParams();
//   const [apiData, setapiData] = useState({});
//   const [originalList, setOriginalList] = useState([]);
//   const iphone = window.navigator.userAgent.includes("Mac");

//   useEffect(() => {
//     const fetchdata = async () => {
//       if (!Userlogin()) {
//         navigate("/Login");
//         return;
//       }
//       try {
//         GetDealerdata().then((res) => {
//           setapiData(res);
//         });
//         const carlist = await fetchDataFromApi(
//           "/api/CarCateloge/AllCatelogebycarnoDealerid?carno=0&carstatus=Catlogue"
//         );
//         setCatloguelist(carlist.Data || []);
//         setOriginalList(carlist.Data || []);
//         setLoading(false);
//       } catch (error) {
//         console.log("Exception Found:", error);
//         setLoading(false);
//       }
//     };
//     fetchdata();
//   }, [navigate, params.id]);

//   const downloadQR = async (name, id) => {
//     setLoading(true);
//     const min = 1;
//     const max = 500;
//     const rand = parseInt(min + Math.random() * (max - min));
//     const canvas1 = await document.getElementById(id);
//     canvas1.style.display = "block";
//     try {
//       html2canvas(canvas1).then((canvas) => {
//         const pngUrl = canvas.toDataURL("image/png");

//         if (iphone) {
//           shareIphonePostMsg({
//             data: pngUrl,
//             action: "sharebase64",
//             filename: name + "QR" + rand + ".pdf",
//           });
//           return setLoading(false);
//         }
//         // android
//         const pdf = new jsPDF();
//         pdf.addImage(pngUrl, "PNG", 12.3, 12.3, 185, 291, "", "SLOW");
//         pdf.save(name + "QR" + rand);
//         setLoading(false);
//         Toast(true, "Qr generated Successfully", "");
//       });
//     } catch (e) {
//       Toast(false, "", e);
//     }

//     canvas1.style.display = "none";
//   };

//   const downloadDetails = async (name, id) => {
//     setLoading(true);
//     // const min = 1;
//     // const max = 500;
//     // const rand = parseInt(min + Math.random() * (max - min));

//     const rand = Math.floor(Math.random() * 500) + 1;
//     const canvas1 = await document.getElementById(id);
//     canvas1.style.display = "block";
//     let filename = name + "Details" + rand + ".pdf";

//     try {
//       const options = {
//         // pagebreak:{ mode: ['avoid-all', 'css', 'legacy'] },
//         margin: [4, 2, 2, 0],
//         filename: filename,
//         image: {
//           type: "jpeg",
//           quality: 1.0,
//         },
//         html2canvas: {
//           scale: 2,
//           dpi: 192,
//           letterRendering: true,
//           allowTaint: true,
//         },
//         jsPDF: {
//           unit: "mm",
//           format: "a4",
//           orientation: "portrait",
//           compress: true,
//         },
//       };
//       if (iphone) {
//         let bs64 = await html2pdf()
//           .from(canvas1)
//           .set(options)
//           .toPdf()
//           .outputPdf("datauristring");
//         return shareIphonePostMsg({
//           data: bs64,
//           filename,
//           action: "sharebase64",
//         });
//       }
//       await html2pdf().from(canvas1).set(options).toPdf().get("pdf").save();
//       Toast(true, "Qr generated Successfully", "");
//     } catch (e) {
//       Toast(false, "", e);
//     } finally {
//       canvas1.style.display = "none";
//       setLoading(false);
//     }
//   };
//   const handleCallback = (childData) => {
//     setLoading(true);
//     setCatloguelist(childData);
//     setLoading(false);
//   };

//   return (
//     <div>
//       <Header />
//       {loading ? <Loader /> : null}
//       <div className="page-space">
//         <Search dataFromParent={originalList} parentCallback={handleCallback} />

//         {catloguelist.length === 0 ? (
//           <NoCars />
//         ) : (
//           catloguelist.map((list, index) => (
//             <div key={list.carid}>
//               <div className="oldcatlg-div">
//                 <div className="oldcatlg-img">
//                   <Link to={"/Catlogue_Detail/" + list.Rand}>
//                     <img src={list.carphoto} className="img-fluid" alt="" />
//                   </Link>
//                 </div>

//                 <div className="oldcatlg-text">
//                   <h2>
//                     {list.modelyear} {list.companyid} {list.carmodelid}{" "}
//                     {list.variantid}
//                   </h2>
//                   <div className="oldcatlg-number">
//                     <span>{list.carnumber}</span>
//                     <span> • {list.km} km</span>
//                     <span> • {list.fueltypeid}</span>
//                   </div>
//                   <button
//                     className="mdbtn border-0 me-2"
//                     onClick={(e) => downloadQR(list.carnumber, list.Rand)}
//                   >
//                     Get QR
//                   </button>
//                   <button
//                     className="mdbtn border-0"
//                     onClick={(e) =>
//                       downloadDetails(list.carnumber, list.Rand + "Detail")
//                     }
//                   >
//                     Get Details
//                   </button>
//                   <div></div>
//                 </div>
//               </div>
//               {/*-------------------generating QrCode--------------------------------  */}
//               <div
//                 id={list.Rand}
//                 style={{ display: "none" }}
//                 className="div_print"
//               >
//                 <div className="text-center">
//                   <span>
//                     <img
//                       src="assets/images/logo.png"
//                       alt=""
//                       style={{ width: "35%" }}
//                     />
//                   </span>
//                 </div>
//                 <div className="qrdiv">
//                   <h2
//                     style={{
//                       fontSize: "30px",
//                       lineHeight: "40px",
//                       fontWeight: "600",
//                       marginBottom: "50px",
//                     }}
//                   >
//                     {list.modelyear} {list.companyid} {list.carmodelid}{" "}
//                     {list.variantid}
//                   </h2>
//                   <QRCode
//                     value={
//                       "https://m.carthi.in/#/Leadform/" +
//                       list.carnumber +
//                       "/" +
//                       list.Rand +
//                       "/" +
//                       apiData.DealerRand
//                     }
//                     size={290}
//                     level={"H"}
//                     includeMargin={true}
//                   />
//                   <h2
//                     style={{
//                       fontSize: "30px",
//                       lineHeight: "40px",
//                       fontWeight: "600",
//                       marginTop: " 30px",
//                     }}
//                   >
//                     {list.carnumber}
//                   </h2>
//                   <div style={{ marginTop: "50px" }}>
//                     <h3
//                       style={{
//                         fontSize: "24px",
//                         lineHeight: "34px",
//                         fontWeight: "500",
//                       }}
//                     >
//                       {apiData.Firmname}
//                     </h3>
//                     <h3
//                       style={{
//                         fontSize: "24px",
//                         lineHeight: "34px",
//                         fontWeight: "500",
//                       }}
//                     >
//                       {apiData.Mobileno}
//                       {apiData.Mobileno1
//                         ? " | " + apiData.Mobileno1.replace("/", " | ")
//                         : " "}
//                     </h3>
//                   </div>
//                   <img
//                     src="assets/images/scissors.png"
//                     className="scissors"
//                     alt=""
//                   />
//                 </div>
//               </div>
//               {/* ---------------------get Details Section-------------- */}
//               <div
//                 id={list.Rand + "Detail"}
//                 style={{ display: "none" }}
//                 className="div_print"
//               >
//                 <div className="text-center">
//                   <span>
//                     <img
//                       src="assets/images/logo.png"
//                       alt=""
//                       style={{ width: "35%" }}
//                     />
//                   </span>
//                 </div>
//                 <div className="qrdiv" style={{ width: "700px", top: "40%" }}>
//                   <h2>
//                     {list.modelyear} {list.companyid} {list.carmodelid}{" "}
//                     {list.variantid}
//                   </h2>
//                   <div className="catlg-number">
//                     <span style={{ fontWeight: "bold" }}>{list.carnumber}</span>
//                     <span style={{ fontWeight: "bold" }}> • {list.km} km</span>
//                     <span style={{ fontWeight: "bold" }}>
//                       {" "}
//                       • {list.fueltypeid}
//                     </span>
//                   </div>
//                   <div className="car-grid">
//                     <div className="car-details print-deail">
//                       <div className="myflex">
//                         <span>
//                           <img src="assets/images/ownership.svg" alt="" />
//                         </span>
//                         <span className="title">Ownership</span>
//                       </div>
//                       <div className="info pt-detailval">
//                         {list?.owner} Owner
//                       </div>
//                     </div>
//                     <div className="car-details print-deail">
//                       <div className="myflex">
//                         <span>
//                           <img src="assets/images/fuel.svg" alt="" />
//                         </span>
//                         <span className="title">Fuel Type</span>
//                       </div>
//                       <div className="info pt-detailval">
//                         {list?.fueltypeid}
//                       </div>
//                     </div>
//                     <div className="car-details print-deail">
//                       <div className="myflex">
//                         <span>
//                           <img src="assets/images/color.svg" alt="" />
//                         </span>
//                         <span className="title">Color</span>
//                       </div>
//                       <div className="info pt-detailval">{list?.colour}</div>
//                     </div>
//                     <div className="car-details print-deail">
//                       <div className="myflex">
//                         <span>
//                           <img src="assets/images/seats.svg" alt="" />
//                         </span>
//                         <span className="title">Seating Capacity</span>
//                       </div>
//                       <div className="info pt-detailval">
//                         {list?.seatingcapicity}
//                       </div>
//                     </div>
//                     <div className="car-details print-deail">
//                       <div className="myflex">
//                         <span>
//                           <img src="assets/images/gear.png" alt="" />
//                         </span>
//                         <span className="title">Gear</span>
//                       </div>
//                       <div className="info pt-detailval">{list?.gear}</div>
//                     </div>
//                     <div className="car-details print-deail">
//                       <div className="myflex">
//                         <span>
//                           <img src="assets/images/sunroof.png" alt="" />
//                         </span>
//                         <span className="title">Sunroof</span>
//                       </div>
//                       <div className="info pt-detailval">{list?.nSunRoof}</div>
//                     </div>
//                     <div className="car-details print-deail">
//                       <div className="myflex">
//                         <span>
//                           <img src="assets/images/insurance.svg" alt="" />
//                         </span>
//                         <span className="title">Insurance</span>
//                       </div>
//                       <div className="info pt-detailval">
//                         {list?.insurance === "Yes"
//                           ? list?.insurance + "-" + list?.nInsurancetype
//                           : list?.insurance}
//                       </div>
//                     </div>
//                     {list?.insurance === "Yes" ? (
//                       <>
//                         <div className="car-details print-deail">
//                           <div className="myflex">
//                             <span>
//                               <img
//                                 src="assets/images/registrationyear.svg"
//                                 alt=""
//                               />
//                             </span>
//                             <span className="title">Insurance End Date</span>
//                           </div>
//                           <div className="info pt-detailval">
//                             {new Date(
//                               list?.insuranceendtdate
//                             ).toLocaleDateString("es-CL")}
//                           </div>
//                         </div>
//                       </>
//                     ) : null}
//                   </div>
//                   <div style={{ marginTop: "50px" }}>
//                     <h3
//                       style={{
//                         fontSize: "24px",
//                         lineHeight: "34px",
//                         fontWeight: "500",
//                       }}
//                     >
//                       {apiData.Firmname}
//                     </h3>
//                     <h3
//                       style={{
//                         fontSize: "24px",
//                         lineHeight: "34px",
//                         fontWeight: "500",
//                       }}
//                     >
//                       {apiData.Mobileno}
//                       {apiData.Mobileno1
//                         ? " | " + apiData.Mobileno1.replace("/", " | ")
//                         : " "}
//                     </h3>
//                   </div>
//                   <img
//                     src="assets/images/scissors.png"
//                     className="scissors"
//                     alt=""
//                   />
//                 </div>
//               </div>
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// }

// export default GenerateQr;
